import { ChatIaMessage } from "./chat-ia.service";

const STORAGE_KEY = "chat-ia:messages";

export const chatIaStorage = {
  load(): ChatIaMessage[] {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(saved) ? saved : [];
    } catch {
      return [];
    }
  },

  // el html se descarta: se regenera desde content al cargar
  save(messages: ChatIaMessage[]): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages.map(({ html, ...rest }) => rest)));
    } catch { /* storage lleno o bloqueado: el chat sigue andando sin persistir */ }
  },

  clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch { /* storage bloqueado */ }
  },
};
